module.exports = __webpack_public_path__ + "media/images/logo-Square284x284Logo-dark-e61d9da79b1cfec5d16ea371b58684f7.png";